import { color, ink } from "@styles";
import { H2 } from "components/atoms/Heading";
import { P1 } from "components/atoms/Paragraph";
import { mobile, tablet } from "components/templates/Breakpoints";
import styled from "styled-components";

export const MapHeader = styled(H2)`
  max-width: 48rem;
  margin: 0 auto;
  line-height: 3.25rem;
  text-align: center;

  ${mobile} {
    font-size: 2rem;
    line-height: 2.5rem;
  }
`;

export const MapSubtitle = styled(P1)`
  margin: 0 auto;
  text-align: center;
  max-width: 55rem;
`;

export const MapConditions = styled(P1)`
  margin: 0 auto;
  text-align: center;
  color: ${ink.inkSubtle};
  font-size: 0.875rem;
  line-height: 1rem;
  max-width: 44rem;
  padding: 0 0 1.25rem;

  ${mobile} {
    font-size: 0.75rem;
    line-height: 0.9rem;
    letter-spacing: 0.075rem;
  }
`;

export const Tooltip = styled.div<{ $isModalOpen: boolean }>`
  position: absolute;
  padding: 0.75rem 1.25rem;
  background-color: #007357;
  color: white;
  border-radius: 0.5rem;
  z-index: 2;
  font-weight: 700;
  pointer-events: none;
  display: ${(p) => (p.$isModalOpen ? "none" : "block")};

  &::before {
    content: "";
    position: absolute;
    border-style: solid;
    border-width: 0.5rem 0.5rem 0 0.5rem;
    border-color: #007357 transparent transparent transparent;
    bottom: -0.4rem;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const HeroLottie = styled.div`
  position: relative;
  bottom: 2rem;
  right: -2rem;
  height: 38rem;
  width: 38rem;
  transform: scale(1.1);

  @media only screen and (max-width: 85rem) {
    width: 32rem;
    top: -5rem;
  }

  ${tablet} {
    right: 0rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 5rem;
  padding: 0 3rem;

  ${tablet} {
    width: 100%;
  }

  ${mobile} {
    margin-top: 0;
  }
`;

export const HeroSubtitle = styled.p`
  text-align: center;
`;

export const LogoContainer = styled.div`
  margin: 2.5rem 0 0;
  width: 100%;
  gap: 4rem;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  @media only screen and (max-width: 60rem) {
    gap: 2rem;
    padding: 0 5rem 0 6rem;
  }
`;

export const CompanyLogo = styled.img`
  ${tablet} {
    transform: scale(0.8);
  }
`;

export const Subtitle = styled.p`
  letter-spacing: 0.075rem;
  text-align: center;
`;

export const VideoWrapper = styled.div`
  max-width: 34rem;

  svg {
    border-radius: 0.5rem;
    display: block;
  }
`;

export const CinemaYugi = styled.div`
  position: absolute;
  right: 0rem;
  bottom: -1rem;
  width: 23rem;

  ${tablet} {
    display: none;
  }
`;
